import auth from "../../middlewares/auth";
export const inquiryTypeRoute = [
  {
    path: '/inquiry/type/list',
    component: () => import(/* webpackChunkName: "inquiryTypes" */ '../../views/inquiry_types/InquiryTypeList'),
    name: 'inquiry_type_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/inquiry/type/add',
    component: () => import(/* webpackChunkName: "inquiryTypes" */ '../../views/inquiry_types/InquiryTypeForm'),
    name: 'inquiry_type_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/inquiry/type/edit/:id',
    component: () => import(/* webpackChunkName: "inquiryTypes" */ '../../views/inquiry_types/InquiryTypeForm'),
    name: 'inquiry_type_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];